module.exports = "https://coursera_assets.s3.amazonaws.com/images/8d15a75421f06a67c3cbf69ae9f3a446.png";